import { createApiService } from "@/core/api/apiService";
import type { CreateFormDto, FormDto, UpdateFormDto } from "../types/formTypes";

export function createFormApiService() {
  const api = createApiService("forms");
  const scope = (businessId: string) => `?${new URLSearchParams({ businessId })}`;
  return {
    getAll: (businessId: string, signal?: AbortSignal) =>
      api.get<FormDto[]>(scope(businessId), { signal }),
    getById: (businessId: string, formId: string, signal?: AbortSignal) =>
      api.get<FormDto>(`${encodeURIComponent(formId)}${scope(businessId)}`, { signal }),
    create: (businessId: string, dto: CreateFormDto) =>
      api.post<FormDto>(scope(businessId), dto),
    update: (businessId: string, formId: string, dto: UpdateFormDto) =>
      api.put<FormDto>(`${encodeURIComponent(formId)}${scope(businessId)}`, dto),
    delete: (businessId: string, formId: string) =>
      api.delete<{ message: string }>(`${encodeURIComponent(formId)}${scope(businessId)}`),
  };
}

export const formApiService = createFormApiService();
